"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var MouseEvent = require("../generated/MouseEvent");

var closest = require("../helpers/traversal").closest;

var domSymbolTree = require("../helpers/internal-constants").domSymbolTree;

function isLabelable(node) {
  // labelable logic defined at: https://html.spec.whatwg.org/multipage/forms.html#category-label
  if (node.nodeType !== 1) {
    return false;
  }

  switch (node.tagName) {
    case "BUTTON":
    case "KEYGEN":
    case "METER":
    case "OUTPUT":
    case "PROGRESS":
    case "SELECT":
    case "TEXTAREA":
      return true;

    case "INPUT":
      return node.type !== "hidden";
  }

  return false;
}

function sendClickToAssociatedNode(node) {
  node.dispatchEvent(MouseEvent.createImpl(["click", {
    bubbles: true,
    cancelable: true,
    view: node.ownerDocument ? node.ownerDocument.defaultView : null,
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    button: 0,
    detail: 1,
    relatedTarget: null
  }]));
}

var HTMLLabelElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLLabelElementImpl, _HTMLElementImpl);

  function HTMLLabelElementImpl() {
    _classCallCheck(this, HTMLLabelElementImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTMLLabelElementImpl).apply(this, arguments));
  }

  _createClass(HTMLLabelElementImpl, [{
    key: "_activationBehavior",
    value: function _activationBehavior() {
      if (this.hasAttribute("for")) {
        var node = this.ownerDocument.getElementById(this.getAttribute("for"));

        if (node && isLabelable(node)) {
          sendClickToAssociatedNode(node);
        }
      } else {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = domSymbolTree.treeIterator(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var descendant = _step.value;

            if (isLabelable(descendant)) {
              sendClickToAssociatedNode(descendant);
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }, {
    key: "form",
    get: function get() {
      return closest(this, "form");
    }
  }]);

  return HTMLLabelElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLLabelElementImpl
};